/**
 * @generated SignedSource<<e330c1180a03b390d2b20e05e9c7d0a0>>
 * @relayHash 38115da88013a42eec2cc79ab69bebaf
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 38115da88013a42eec2cc79ab69bebaf

import type { ConcreteRequest } from 'relay-runtime';
export type PendingIssueSuggestionKind = "ASSIGNEE" | "FIELD" | "LABEL" | "TYPE" | "%future added value";
export type ApplyPendingIssueSuggestionsInput = {
  actorId: string;
  clientMutationId?: string | null | undefined;
  issueId: string;
  suggestions: ReadonlyArray<PendingIssueSuggestionRef>;
};
export type PendingIssueSuggestionRef = {
  assigneeId?: string | null | undefined;
  issueFieldId?: string | null | undefined;
  issueTypeId?: string | null | undefined;
  kind: PendingIssueSuggestionKind;
  labelId?: string | null | undefined;
};
export type applyPendingIssueSuggestionsMutation$variables = {
  input: ApplyPendingIssueSuggestionsInput;
};
export type applyPendingIssueSuggestionsMutation$data = {
  readonly applyPendingIssueSuggestions: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type applyPendingIssueSuggestionsMutation = {
  response: applyPendingIssueSuggestionsMutation$data;
  variables: applyPendingIssueSuggestionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ApplyPendingIssueSuggestionsPayload",
    "kind": "LinkedField",
    "name": "applyPendingIssueSuggestions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "applyPendingIssueSuggestionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "applyPendingIssueSuggestionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "38115da88013a42eec2cc79ab69bebaf",
    "metadata": {},
    "name": "applyPendingIssueSuggestionsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a134f326abbba589a5a5713da3e08f36";

export default node;
